export default __webpack_public_path__ + "static/media/ssl_certificate.f551ab59.svg";